var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { Translate } from "../../../I18N";
import { Map } from "../../../Map/MapContainer";
import { Label, InputField } from "./";



















const Geolocation = ({
  name,
  onChange,
  className,
  disabled,
  label,
  zoom,
  value = {},
  layers
}) => {
  const [currentLatitude, setCurrentLatitude] = useState(value === null || value === void 0 ? void 0 : value.lat);
  const [currentLongitude, setCurrentLongitude] = useState(value === null || value === void 0 ? void 0 : value.lon);
  const [currentMarkers, setCurrentMarkers] = useState(undefined);

  const latChange = (e) => {
    setCurrentLatitude(e.target.valueAsNumber);
    if (onChange) {
      onChange({ lat: e.target.valueAsNumber, lon: currentLongitude });
    }
  };

  const lonChange = (e) => {
    setCurrentLongitude(e.target.valueAsNumber);
    if (onChange) {
      onChange({ lat: currentLatitude, lon: e.target.valueAsNumber });
    }
  };

  const clearCoordinates = () => {
    setCurrentLatitude(undefined);
    setCurrentLongitude(undefined);
    setCurrentLatitude(undefined);
    if (onChange) {
      onChange({ lat: undefined, lon: undefined });
    }
  };

  useEffect(() => {
    if (currentLatitude && currentLongitude) {
      setCurrentMarkers([
      {
        latitude: currentLatitude,
        longitude: currentLongitude,
        properties: {}
      }]
      );
    }
  }, [currentLatitude, currentLongitude, setCurrentMarkers]);

  const mapClick = ({ lngLat }) => {
    if (disabled) return;
    const [lon, lat] = lngLat;
    setCurrentLatitude(lat);
    setCurrentLongitude(lon);
    if (onChange) {
      onChange({ lat, lon });
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: className }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: name }, void 0, label), /*#__PURE__*/
    _jsx(Map, {
      onClick: mapClick,
      height: 370,
      showControls: true,
      zoom: zoom,
      layers: layers,
      markers: currentMarkers || [] }
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-4" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      className: "grow",
      onChange: latChange,
      disabled: disabled,
      clearFieldAction: clearCoordinates,
      value: currentLatitude || '',
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Latitude"),
      id: "lat",
      name: `${name}[lat]` }
    ), /*#__PURE__*/
    _jsx(InputField, {
      className: "grow",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Longitude"),
      onChange: lonChange,
      disabled: disabled,
      clearFieldAction: clearCoordinates,
      value: currentLongitude || '',
      id: "lon",
      name: `${name}[lon]` }
    )
    )
    ));

};

export { Geolocation };